export const DEFAULT_ROUTE: string = '/';
export const CONTACT_ROUTE = 'contact';
export const RFP_ROUTE = 'rfp'
export const TERMS_ROUTE = '/terms'
export const ABOUT_ROUTE = '/about'



